<template>
    <div>
        <price-element-nights :amount.sync="service.duration"></price-element-nights>
        <price-element-breakfast :breakfast.sync="service.breakfast"></price-element-breakfast>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    service: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/Perperson.vue